<template>
  <div>
    <h2>Oops..</h2>
    <p>The page you're looking for has gone missing :(</p>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style lang="sass" scoped>
  div {
    color: $catalina-blue;

    p {
      font-weight: bold;
    }
  }
</style>